
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import TestModeModal from './TestModeModal.vue'

@Component<TestMode>({
    components: {
        TestModeModal,
    },
})
export default class TestMode extends Vue {
    @Prop({ type: Boolean, required: false, default: true })
    public readonly isAdmin?: boolean

    public showModal = false

    private toggleModal() {
        this.showModal = !this.showModal
    }
}
